<script lang="ts">
    import {authFetch} from "../Auth";
    import {overlay} from "../Store";
    import type {MessageData} from "../Types";
    import type {UserData} from "../Types";
    import type {ChatData} from "../Types";
    import Sort from "../Component/Sort.svelte";
    import throttle from "@jcoreio/async-throttle";
    import {getRouteById} from "../Nav";
    import {DateTime} from "luxon";
    import Message from "../Component/Message.svelte";

    export const params = {}
    let filter = {
        offset: 0,
        limit: 100,
        phrase: "",
        targetPhone: null,
        order: "DESC",
        orderBy: "date"
    }
    let messages: MessageData[] = []
    let chats: {
        [key: string]: ChatData
    }
    let users: {
        [key: string]: UserData
    } = {}
    let count: number = 0
    let listPromise: Promise<any>

    let onInput = throttle(()=>{
        update()
    }, 1000)

    async function loadList() {
        let response = await authFetch('messages/search', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            messages = data?.messages ?? []
            chats = data?.chats ?? []
            users = data?.users ?? []
            console.log(chats)
            console.log(users)
            count = data.count
        } else {
            alert(response.statusText)
        }
    }

    function onSort(ev: Event){
        if(ev.detail.order === null){
            filter.order = "DESC"
            filter.orderBy = "date"
        } else {
            filter.order = ev.detail.order
            filter.orderBy = ev.detail.orderBy
        }
        update()
    }

    function update(){
        listPromise = loadList()
    }
    update()
</script>
<table class="table table-bordered table-sm">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
        <tr style="border: 0px;">
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Номер цілі"
                       bind:value={filter.targetPhone} on:keyup={onInput} on:change={onInput}>
            </div>
        </tr>
        <tr style="border: 0px;">
            <th colspan="100">
                <div class="input-group">
                    <input class="form-control" type="search" placeholder="Текс повідомлення"
                        bind:value={filter.phrase} on:keyup={onInput} on:change={onInput}>
                    <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                           min="1"
                           max={Math.floor(count / filter.limit)+1}
                           step="1"
                           value={(filter.offset / filter.limit)+1}
                           on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                    >
                    <button class="btn btn-info disabled">
                        / {Math.floor(count / filter.limit)+1}
                    </button>
                    <button class="btn btn-info"
                            class:disabled={messages.length < filter.limit}
                            on:click={()=>{filter.offset+=filter.limit;update()}}>
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr style="border: 0px; font-size: 14px;">
            <th>Ім'я</th>
            <th>Телефон</th>
            <th>Чат</th>
            <th>Тип</th>
            <th style="min-width: 70px">ID повід</th>
            <th>Дата <Sort orderBy="date" state={filter} orders={["ASC","DESC"]} on:sort={onSort}></Sort></th>
            <th style="min-width: 400px">Текст</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if messages.length > 0}
            {#each messages as message}
                <tr>
                    {#if message.telegram_user_id in users}
                        {@const user = users[message.telegram_user_id]}
                        <td rowspan="1">{user.names.length > 0 ?
                            user.names.map((item) => item.name).join(', ') :
                            '-'
                        }</td>
                        <td rowspan="1">{user.phone ?? '-'}</td>
                    {:else }
                        <td>-</td>
                        <td>-</td>
                    {/if}
                    {#if message.telegram_chat_id in chats}
                        {@const chat = chats[message.telegram_chat_id]}
                        {@const user = users[message.telegram_user_id]}
                        {#if chat.title.length < 1}
                            <td><a href="#{getRouteById('UserChats').hash(user.id, chat.id)}">{chat.id}</a></td>
                        {:else}
                            <td><a href="#{getRouteById('UserChats').hash(user.id, chat.id)}">{chat.title ?? '-'}</a></td>
                        {/if}
                        <td>
                            {#if chat.type === 'chatTypeSupergroup'}
                                Канал
                            {:else if chat.type === 'chatTypeBasicGroup'}
                                Група
                            {:else if chat.type === 'chatTypePrivate'}
                                Чат
                                <!--{if chat.contact.}-->
                            {:else}
                                {chat.type}
                            {/if}
                        </td>
                    {:else }
                        <td>-</td>
                        <td>-</td>
                    {/if}
                    <td>{message.message_id}</td>
                    <td>{message.date}</td>
                    <td>
                        {#if message.forward_origin_date != null && message.forward_origin_type != null}
                            <div class="card">
                                <div class="card-header">
                                    Переслано
                                    {#if message.forward_origin_type == 'messageForwardOriginChannel'}
                                        з каналу: {message.forward_info?.origin?.chat_id ?? '-'}
                                    {:else if message.forward_origin_type == 'messageForwardOriginUser'}
                                        від користувача: {message.forward_info?.origin?.sender_user_id ?? '-'}
                                    {:else if message.forward_origin_type == 'messageForwardOriginHiddenUser'}
                                        від прихованого користувача: {message.forward_info?.origin?.sender_name ?? '-'}
                                    {/if}, дата: {message.forward_origin_date? DateTime.fromISO(message.forward_origin_date).toFormat("yyyy-MM-dd HH:mm:ss") : ''}
                                </div>
                                <div class="card-body">
                                    <Message entity={message.content} isChannel="0"
                                             telegramUserId="{message.telegram_user_id}"
                                 telegramChatId="{message.telegram_chat_id}"
                                 telegramMessageId="{message.telegram_message_id}"
                                             attachments={message.attachments}/>
                                </div>
                            </div>
                        {:else }
                            <Message entity={message.content} isChannel="0"
                                     telegramUserId="{message.telegram_user_id}"
                                 telegramChatId="{message.telegram_chat_id}"
                                 telegramMessageId="{message.telegram_message_id}"
                                     attachments={message.attachments}/>
                        {/if}
                    </td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає повідомлень</div>
                </td>
            </tr>
        {/if}
    {:catch error}
        <tr>
            <td colSpan="1000" class="text-center">
                <div class="alert alert-danger">{error}</div>
            </td>
        </tr>
    {/await}
</tbody>
</table>
